// @flow
import type {Effect} from '../../types'

import {
  take,
  call,
} from 'redux-saga/effects'
import {
  actionTypes as routerTypes,
} from 'redux-router5'

import {hideMap} from '../../map/lib/hideMap'

export function* enterSignInEffect(): Effect {
  while (true) {
    const {payload: {route}} = yield take(routerTypes.TRANSITION_SUCCESS)
    if (route.name === 'sign-in') {
      yield call(hideMap)
    }
  }
}